export default {"src":"/_next/static/media/diamond-blue.84f2e64b.svg","height":83,"width":90,"blurWidth":0,"blurHeight":0};